import { Text, Container, Icon, Spacer, hooks } from 'roadie-ui'
import ButtonLink from '../../Button/ButtonLink'
import { StatColor } from 'util/scorecard'

type MyStatsPanelProps = {
  label: string
  rate: number
  to: string
  getStatColor: (rate: number, isDarkMode: boolean) => StatColor
  isLast?: boolean
}

export const MyStatsPanel: React.FC<MyStatsPanelProps> = ({ label, rate, to, getStatColor, isLast = false }) => {
  const isDarkMode = hooks.usePreferredColorScheme() === 'dark'
  const color = getStatColor(rate, isDarkMode)
  const wholeNumberRate = Math.floor(rate)

  return (
    <Container.Grid
      $padding="1.6rem"
      $gridTemplateColumns="1fr max-content"
      $alignItems="center"
      $borderColor="neutral-light"
      $borderStyle="solid"
      $borderWidth={isLast ? '0' : '0 0 1px 0'}
    >
      <Container.Grid $textAlign="left">
        <Text.Caption $whiteSpace="nowrap">{label}</Text.Caption>
        <Spacer $height="0.4rem" />
        <Text.Subtitle1 $color={color} $whiteSpace="nowrap">
          {wholeNumberRate}%
        </Text.Subtitle1>
      </Container.Grid>
      <ButtonLink variant="tertiary" type="button" to={to}>
        <Container.Grid $justifyItems="end">
          <Icon.ChevronRight $color="neutral-base" $width="2.4rem" $height="2.4rem" />
        </Container.Grid>
      </ButtonLink>
    </Container.Grid>
  )
}
